import { arrayToSelectOptions } from "../../../utils/arrayToSelectOptions";

const GetEqTypeOptions = (equipmentTypes) =>
  arrayToSelectOptions(
    equipmentTypes.map((eq) => eq.type),
    true,
  );
// export const GetEquipmentTypeOptions = (equipmentTypes) => GetEqTypeOptions(equipmentTypes.filter((eq) => eq.type !== "Relay"));
// export const GetRelayTypeOptions = (equipmentTypes) => GetEqTypeOptions(equipmentTypes.filter((eq) => eq.type === "Relay"));

export const genericATypeEquipType = (equipmentTypes, aType) => {
  // non relay and not CMA asset type are checked for fetching equipment types matching the asset type
  if (aType) return GetEqTypeOptions(equipmentTypes.filter((eq) => eq.aType === aType));
  // if empty asset type argument value is received it fallbacks to generic equipment types
  return GetEqTypeOptions(equipmentTypes.filter((eq) => !eq.aType));
};
export const GetEquipmentTypeIconsObject = (equipmentTypes) =>
  equipmentTypes
    .map((eq) => ({
      iconGroup: eq.iconGroup,
      type: eq.type,
    }))
    .reduce((result, eq) => {
      result[eq.type] = eq.iconGroup;
      return result;
    }, {});
export const GetEquipmentTypeFormFields = (equipmentTypes, type) => {
  let fields = equipmentTypes.find((eq) => eq.type === type);
  const Schema = fields ? checkAndAddAcceptedFormatsInFileIfNotPresent(fields.schema) : [];
  return Schema.map((field) => {
    let thresholdField = getThresholdField(field);
    let dateField = field.type === "date" || field.type === "dateTime" ? { formatAsString: true, format: "MM-DD-yy" } : {};
    return {
      col: 4,
      labelValue: field.label,
      ...thresholdField,
      ...dateField,
      ...field,
    };
  });
};

function getThresholdField(field) {
  let thresholdField = {};
  if (field.type === "threshold" && field.targetId)
    thresholdField = {
      thresholdTargetId: {
        targetSecId: "equipmentInfoAttributesSection",
        targetFieldId: `attributes.${field.targetId}`,
      },
    };

  return thresholdField;
}
function checkAndAddAcceptedFormatsInFileIfNotPresent(schema) {
  return schema.map((field) => {
    if (field.type === "file" && !field.acceptedFormats) {
      return {
        ...field,
        acceptedFormats: [
          ".csv",
          ".pdf",
          ".doc",
          ".docx",
          ".xls",
          ".xlsx",
          ".ppt",
          ".pptx",
          ".txt",
          ".rtf",
          ".jpeg",
          ".jpg",
          ".png",
          ".mp3",
          ".ogg",
          ".wav",
          ".hex",
          ".bin",
          ".elf",
          ".zip",
          ".rar",
          ".gz",
          ".jar",
          ".war",
          ".apk",
        ],
      };
    }
    return field;
  });
}



// WEBPACK FOOTER //
// ./src/components/AssetEquipmentTreeView/equipmentTypes/index.js